import type { RouteLocation } from "vue-router";
import type { ActionContext, ActionTree, MutationTree } from "vuex";

function getSidebarStatus(): string | null {
  if (typeof localStorage === "undefined") {
    return null;
  }
  return localStorage.getItem("sidebarStatus");
}

function setSidebarStatus(status: "0" | "1"): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  localStorage.setItem("sidebarStatus", status);
}

const sidebarStatus: string | null = getSidebarStatus();
export interface AppSidebarType {
  opened: boolean;
  topMenuOpen: boolean;
  withoutAnimation: boolean;
  noSideBar: boolean;
}
export type DeviceType = "desktop" | "app";
export type AppStateRouteType = RouteLocation | null;
export interface AppStateType {
  sidebar: AppSidebarType;
  device: DeviceType;
  storeInfoData:any;
  route: AppStateRouteType;
  pageLoading: boolean;
}

export const state: AppStateType = {
  sidebar: {
    opened: typeof sidebarStatus == "string" ? !!+sidebarStatus : true,
    topMenuOpen: false,
    withoutAnimation: false,
    noSideBar: false,
  },
  storeInfoData:null,
  device: "desktop",
  route: null,
  pageLoading: false,
};

const mutations: MutationTree<AppStateType> = {
  SET_PAGE_LOADING: (state: AppStateType, status: boolean): void => {
    state.pageLoading = false;
  },
  TOGGLE_SIDEBAR: (state: AppStateType): void => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      setSidebarStatus("1");
    } else {
      setSidebarStatus("0");
    }
  },
  TOGGLE_TOP_MENU: (state: AppStateType, status: boolean) => {
    state.sidebar.topMenuOpen = status;
  },
  CLOSE_SIDEBAR: (state: AppStateType, withoutAnimation: boolean) => {
    setSidebarStatus("0");
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state: AppStateType, device: DeviceType) => {
    state.device = device;
  },
  NO_SIDEBAR: (state: AppStateType, status: boolean) => {
    state.sidebar.noSideBar = status;
  },
  SET_ROUTE: (state: AppStateType, route: RouteLocation) => {
    state.route = route;
  },
  SET_STORE_INFO_DATA: (state: AppStateType, storeInfoData: any) => {
     try {
        if(typeof storeInfoData.offiaccountFollowUrl === 'string'){
          storeInfoData.offiaccountFollowData = JSON.parse(storeInfoData.offiaccountFollowUrl) || {}
          storeInfoData.offiaccountFollowData.otherJson = JSON.parse(storeInfoData.offiaccountFollowData.otherJson || '{}') || {}
        }
      } catch (e) {
        console.log(e)
      }
      if (!storeInfoData.offiaccountFollowData) {
        storeInfoData.offiaccountFollowData = {
              otherJson: {}
          }
      }
 
    state.storeInfoData = storeInfoData;
  },
};

const actions: ActionTree<AppStateType, any> = {
  toggleSideBar(store: ActionContext<AppStateType, any>): void {
    store.commit("TOGGLE_SIDEBAR");
  },
  setRoute(
    store: ActionContext<AppStateType, any>,
    route: RouteLocation
  ): void {
    store.commit("SET_ROUTE", route);
  },
  toggleTopMenuSideBar(store: ActionContext<AppStateType, any>, status): void {
    store.commit("TOGGLE_TOP_MENU", status);
  },
  closeSideBar(
    store: ActionContext<AppStateType, any>,
    { withoutAnimation }
  ): void {
    store.commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleDevice(store: ActionContext<AppStateType, any>, device): void {
    store.commit("TOGGLE_DEVICE", device);
  },
  noSideBar(store: ActionContext<AppStateType, any>, status): void {
    store.commit("NO_SIDEBAR", status);
  },
  
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
